import React, { useEffect } from 'react'
import { chatState, useProjectStore, useTimeZoneStore } from '../../zustand';
import { analyticsStore, useBookingStore } from '../../zustand';
import { useAdminRoomManager } from '../../hooks/useAdminRoomManager';

function Initialize({ children }) {
    const { fetchProjects, loadStatus } = useProjectStore();
    const { fetchTimezones } = useTimeZoneStore()
    const { getAnalytics } = analyticsStore()
    const { fetchBookings } = useBookingStore()
    const { unread, projectUnread } = useAdminRoomManager()
    const setUnread = chatState((state) => state.setUnread);
    const setProjectUnread = chatState((state) => state.setProjectUnread);

    useEffect(() => {
        if (unread?.messages) {
            setUnread(unread.messages.length);
        }
        if (projectUnread?.messages) {
            setProjectUnread(projectUnread.messages.length);
        }
    }, [unread, projectUnread]);

    useEffect(() => {
        fetchProjects(1, 1);
        loadStatus()
        fetchTimezones()
        getAnalytics()
        fetchBookings(1)
    }, []);

    return (
        <>{children}</>
    )
}

export default Initialize